// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"482":"dd309a94","921":"304f6dfc"}[chunkId] + ".chunk.css";
};